<div class="sd-html" id="corporate_structure_office_list">
  <div *ngFor="let office of offices" class="corporate-structure-office-list-card">
    <div class="corporate-structure-office-list-header" (click)="toggleDetails(office)">
      <div>
        <p>[ID {{office.office_nrds_id}}] {{office.business_name}}</p>
        <p>Branches: {{office.branches_count}} | Agents: {{office.members_count}}</p>
      </div>
      <label class="corporate-structure-office-list-toggle-label" *ngIf="office.branches_count > 0">{{ office.showDetails ? '-' : '+' }}</label>
    </div>
    <div class="corporate-structure-office-list-details" *ngIf="office.showDetails">
      <div *ngFor="let branch of office.branches">
        <p><strong>Office:</strong> [ID {{branch.office_nrds_id}}] {{branch.business_name}}</p>
        <p><strong>Designated Licensee:</strong> {{branch.dl_name}} | <strong>Agents:</strong> {{branch.members_count}}</p>
      </div>
    </div>
  </div>
</div>
<tg-spinner [blockAll]="true" *ngIf="isItLoading()"></tg-spinner>
